import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useDeletePresenceZone(
  camId: string,
  zoneId: string,
  onSuccess?: () => void
) {
  const url = `/v2/orm/presence/zones/${zoneId}`;
  const request = new Request(url, { method: 'DELETE' });

  return useAuthenticatedMutation<null, null>(request, {
    getBody: () => null,
    onSuccessInvalidationKeys: [
      ['presence-zones', camId],
      ['presence-latest', camId],
      ['presence-rules', camId],
    ],
    onSuccess,
  });
}

export default useDeletePresenceZone;
